<template>
  <div class="skeleton-create-audience">
    <Skeleton class="mb-4" width="30%" height="3rem" />
    <Skeleton class="mb-4" width="60%" height="2rem" />
    <div class="d-flex gap-3 mb-5">
      <Skeleton width="30%" height="2.5rem" />
      <Skeleton width="30%" height="2.5rem" />
    </div>
    <Skeleton class="mb-2" width="60%" height="2rem" />
    <div class="d-flex flex-column mb-3">
      <Skeleton width="20%" height="3rem" />
      <Skeleton width="100%" height="10rem" />
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <Skeleton width="10%" height="3rem" />
      <Skeleton width="10%" height="3rem" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style lang="scss" scoped></style>
